import React from 'react';
import { Link } from 'react-router-dom';
import Button from './Button';
import { MessageSquareIcon, ClockIcon } from 'lucide-react';
const Hero = () => {
  return <section className="pt-16 pb-24 bg-cream overflow-hidden" data-id="element-44">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-45">
        <div className="lg:grid lg:grid-cols-12 lg:gap-8" data-id="element-46">
          <div className="lg:col-span-6 flex flex-col justify-center" data-id="element-47">
            <h1 className="text-4xl md:text-5xl font-bold font-display text-charcoal leading-tight" data-id="element-48">
              Your AI Sous Chef for Customer Communications
            </h1>
            <p className="mt-6 text-xl text-sage max-w-3xl" data-id="element-49">
              Set up in 5 minutes, reclaim 12+ hours weekly for what matters
              most
            </p>
            <div className="mt-8 flex flex-col sm:flex-row space-y-4 sm:space-y-0 sm:space-x-4" data-id="element-50">
              <Link to="/signup" className="inline-flex justify-center items-center px-6 py-3 border border-transparent text-base font-medium rounded-md text-white bg-burgundy hover:bg-burgundy/90 transition-colors" data-id="element-51">
                Start Your Free Trial
              </Link>
              <Button variant="outline" size="lg" data-id="element-52">
                Watch Demo
              </Button>
            </div>
            <div className="mt-10 grid grid-cols-2 gap-x-4 gap-y-2" data-id="element-53">
              <div className="flex items-center text-sm text-charcoal" data-id="element-54">
                <ClockIcon size={18} className="mr-2 text-burgundy" data-id="element-55" />
                <span data-id="element-56">5-minute setup</span>
              </div>
              <div className="flex items-center text-sm text-charcoal" data-id="element-57">
                <MessageSquareIcon size={18} className="mr-2 text-burgundy" data-id="element-58" />
                <span data-id="element-59">24/7 customer service</span>
              </div>
              <div className="flex items-center text-sm text-charcoal" data-id="element-60">
                <svg className="w-5 h-5 mr-2 text-burgundy" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" data-id="element-61">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" data-id="element-62" />
                </svg>
                <span data-id="element-63">No credit card required</span>
              </div>
              <div className="flex items-center text-sm text-charcoal" data-id="element-64">
                <svg className="w-5 h-5 mr-2 text-burgundy" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" data-id="element-65">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" data-id="element-66" />
                </svg>
                <span data-id="element-67">Cancel anytime</span>
              </div>
            </div>
          </div>
          <div className="mt-12 lg:mt-0 lg:col-span-6" data-id="element-68">
            <div className="relative h-64 sm:h-80 lg:h-full" data-id="element-69">
              <img className="absolute inset-0 w-full h-full object-cover rounded-lg shadow-xl" src="https://images.unsplash.com/photo-1581349485608-9469926a8e5e?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1000&q=80" alt="Restaurant owner cooking while phone shows AI handling customer messages" data-id="element-70" />
              <div className="absolute -bottom-6 -right-6 bg-white p-4 rounded-lg shadow-lg max-w-xs" data-id="element-71">
                <div className="flex items-start space-x-3" data-id="element-72">
                  <div className="flex-shrink-0" data-id="element-73">
                    <div className="w-10 h-10 rounded-full bg-burgundy flex items-center justify-center text-white" data-id="element-74">
                      <MessageSquareIcon size={20} data-id="element-75" />
                    </div>
                  </div>
                  <div data-id="element-76">
                    <p className="text-xs text-gray-500" data-id="element-77">Incoming message</p>
                    <p className="text-sm font-medium" data-id="element-78">
                      Do you have any tables available tonight for 4 people at
                      7pm?
                    </p>
                    <div className="mt-2 flex justify-between" data-id="element-79">
                      <p className="text-xs text-burgundy font-semibold" data-id="element-80">
                        ChefChat is responding...
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
};
export default Hero;